"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultHeaders_1 = __importDefault(require("../../getDefaultHeaders"));
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
/**
 * Retrieve roles for a tenant
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param tenantKey If this parameter is passed, we will filter out those roles that cannot be assigned to that tenant
 * @param roles A comma-separated list of role ids. This will return users that have any of the roles passed in this parameter. An empty list will return status code 1023/400.
 * @param isManagedByOther List users that are managed by some other organization
 * @param cursor This parameter is used to iterate through the listing. Initially it can be null, but on subsequent calls it must be read from the response.
 * @param limit Used for pagination. Indicates the maximum number of results we will return on each page. Maximum value is 100, negative values are not allowed. If any of those two situations arises status 1023/400 will be returned.
 */
function getUsersWithRoles(baseUrl, wardenToken, tenantKey, roles, isManagedByOther, cursor, limit) {
    if (isManagedByOther === void 0) { isManagedByOther = false; }
    if (cursor === void 0) { cursor = ""; }
    if (limit === void 0) { limit = 100; }
    var rolesString = roles.join(",");
    var managedBy = isManagedByOther ? "&isManagedByOther=true" : "";
    return http_client_1.default({
        method: "GET",
        url: baseUrl + "/api/v4/tenants/" + tenantKey + "/users?roles=" + rolesString + managedBy + "&cursor=" + cursor + "&limit=" + limit,
        headers: __assign(__assign({}, getDefaultHeaders_1.default(tenantKey)), { Authorization: "Bearer " + wardenToken })
    }).then(function (response) { return response.data; });
}
exports.default = getUsersWithRoles;
